import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPersonalizado} from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';

const EditarDatosDeEscritos = ({title, openFullScreenDialog, handleClose, datossDelTarifario, accionRegistroEditado}) => {
    const dispatch = useDispatch();
    const {datosGenerales} = useSelector((state) => state);
    const [catalogoTipoDeCirculacionDeMedioEscrito] = useState('catalogoTipoDeCirculacionDeMedioEscrito');
    const [catalogoTipoDeMedioEscrito] = useState('catalogoTipoDeMedioEscrito');
    const [catalogoTipoDeDistribucionDeMedioEscrito] = useState('catalogoTipoDeDistribucionDeMedioEscrito');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeError: 'error', tipoDeMensaje: '', abrirRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);

    useEffect(() => {
        obtenerTiposDeCirculacion();
        obtenerTiposDeMedioEscrito();
        obtenerTipoDeDistribucionDelMedio();
    },[])

    const obtenerTiposDeCirculacion = async () => {
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.tiposDeCirculacionDelMedio.length > 0) {
            copiaDeCampos.circulacion.list = datosGenerales.tiposDeCirculacionDelMedio?.map( ({id, descripcion}) => ({id , name: descripcion}) );
            return setCamposDelFormulario(copiaDeCampos);
        }

        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({
            controller: catalogoTipoDeCirculacionDeMedioEscrito,
            validateIfDataExists: true,
            stateInStore: datosGenerales.tiposDeCirculacionDelMedio,
            dispatchAction: nombreDeAcciones.SETEAR_TIPOS_DE_CIRCULACION_DEL_MEDIO,
        }));

        setcargandoSolicitud(false);

        if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        copiaDeCampos.circulacion.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
        setCamposDelFormulario(copiaDeCampos);
    }

    const obtenerTiposDeMedioEscrito = async () => {
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.tipoDeMedioEscrito.length > 0) {
            copiaDeCampos.tipoEscrito.list = datosGenerales.tipoDeMedioEscrito?.map( ({id, descripcion}) => ({id , name: descripcion}) );
            return setCamposDelFormulario(copiaDeCampos);
        }

        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({
            controller: catalogoTipoDeMedioEscrito,
            validateIfDataExists: true,
            stateInStore: datosGenerales.tipoDeMedioEscrito,
            dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_MEDIOS_ESCRITO,
        }));

        setcargandoSolicitud(false);

        if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        copiaDeCampos.tipoEscrito.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
        setCamposDelFormulario(copiaDeCampos);
    }

    const obtenerTipoDeDistribucionDelMedio = async () => {
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.tipoDeDistribucionDelMedio.length > 0) {
            copiaDeCampos.distribucion.list = datosGenerales.tipoDeDistribucionDelMedio?.map( ({id, descripcion}) => ({id , name: descripcion}) );
            return setCamposDelFormulario(copiaDeCampos);
        }

        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({
            controller: catalogoTipoDeDistribucionDeMedioEscrito,
            validateIfDataExists: true,
            stateInStore: datosGenerales.tipoDeDistribucionDelMedio,
            dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_DISTRIBUCION_DEL_MEDIO,
        }));

        setcargandoSolicitud(false);

        if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        copiaDeCampos.distribucion.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
        setCamposDelFormulario(copiaDeCampos);
    }

    const {
      tipoDeCirculacionDeMedioEscrito, tipoDeDistribucionDeMedioEscrito, tipoDeMedioEscrito,
        medioDeComunicacion: {
            nombre, logo, nit_empresa,
            detallesDeMedioDeComunicacion:{
                descripcion, correoDeRecepcion, diasDeAnticipacion, especTecnicasDelMaterial, porcentajeAudienciaHombres,
                porcentajeAudienciaMujeres, nivelSocioEconomicoAlto, nivelSocioEconomicoMedio, nivelSocioEconomicoBajo,
                ratingDelMedio, alcanceEnPersonas,
            },
        }
    } = datossDelTarifario;

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
      tituloDatosDelMedioEscrito:{
          idelement: "tituloDatosDelMedioEscrito", title:'Datos del medio escrito', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDatosDelMedioEscrito", value: "", isError:false,
      },
      nombreDelMedioEscrito: {
          idelement: "nombreDelMedioEscrito", value: nombre, label: "Nombre del medio escrito *", pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”()-*_/@]{4,100}$", validators: ['required'], errorMessages:['El campo es requerido, sin espacios al inicio y final'], isError:false, elementType:'texto', name:"nombreDelMedioEscrito", 'disabled': false, width: '25%'
      },
      circulacion: {
          idelement: "circulacion", value: {id: tipoDeCirculacionDeMedioEscrito?.id, name: tipoDeCirculacionDeMedioEscrito?.descripcion }, label: "Circulacion *", pattern:"^[1-9][0-9]*$", validators: ['required'],
          errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '25%'
      },
      distribucion: {
          idelement: "distribucion", value: {id: tipoDeDistribucionDeMedioEscrito?.id, name: tipoDeDistribucionDeMedioEscrito?.descripcion }, label: "Distribucion *", pattern:"^[1-9][0-9]*$", validators: ['required'],
          errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "Gratuita"}, {id: 2, name: "Voceador"}, {id: 3, name: "Suscriptores"}], handler: undefined, width: '25%'
      },
      logoDelMedio:{
          idelement: "logoDelMedio", value: logo ? logo.includes('base64,') ? logo : `data:image/jpeg;base64,${logo}` : "", label: "LOGO", validators: {required: true,  size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"logoDelMedio", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '25%', type: "file"
      },
      descripcionDelMedio:{
          idelement: "descripcionDelMedio", value: descripcion, label: `Descripción del medio escrito`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'],
          errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionDelMedio", width: '100%'
      },
      tituloEspecificaciones:{
          idelement: "tituloEspecificaciones", title:'Especificaciones Técnicas', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloEspecificaciones", value: "", isError:false,
      },
      correoElectronico: {
        idelement: "correoElectronico", value: correoDeRecepcion, label: "Correo electrónico para recepción de materiales *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', name:"correoElectronico", width: "50%"
      },
      diasDeAnticipacion: {
          idelement: "diasDeAnticipacion",  value: diasDeAnticipacion, label: "Días de anticipación para entregar el material a pautar *", pattern:"^[0-9]{1,5}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"diasDeAnticipacion", 'disabled': false, width: "50%"
      },
      comentarioEspecificaciones:{
          idelement: "comentarioEspecificaciones", value: especTecnicasDelMaterial, label: `Especificaciones técnicas del material`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "comentarioEspecificaciones", width: '100%'
      },
      tituloRegistroPrograma:{
        idelement: "tituloRegistroPrograma", title:'Qué tipo de escrito es?', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloRegistroPrograma", value: "", isError:false,
      },
      tipoEscrito: {
        idelement: "tipoEscrito", value: {id: tipoDeMedioEscrito?.id, name: tipoDeMedioEscrito?.descripcion } , label: "Qué tipo de escrito es? * ", pattern:"", validators: ['required'],
        errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "Periodico"}, {id: 2, name: "Revista"}], handler: undefined, width: '25%'
      },
      ratingAlcanceTitulo:{
          idelement: "ratingAlcanceTitulo", title:'RATING Y ALCANCE', position:"center", elementType:'titulo', showTitleForm: true, name: "ratingAlcanceTitulo", value: "", isError:false,
      },
      ratingCanal: {
          idelement: "ratingCanal",  value: ratingDelMedio, label: `Ingrese el rating *`,pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"ratingCanal", 'disabled': false, width: '30%',
      },
      alcancePersonas: {
          idelement: "alcancePersonas",  value: alcanceEnPersonas, label: "Ingrese el alcance en personas *", pattern:"^[0-9]{1,11}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"alcancePersonas", 'disabled': false, width: '30%'
      },
      perfilAudenciaTitulo:{
          idelement: "perfilAudenciaTitulo", title:'PERFIL DE LA AUDIENCIA EXPUESTA', position:"center", elementType:'titulo', showTitleForm: true, name: "perfilAudenciaTitulo", value: "", isError:false,
      },
      generoTitulo:{
          idelement: "generoTitulo", title:'GÉNERO', position:"center", elementType:'titulo', showTitleForm: true, name: "generoTitulo", value: "", isError:false, widthTitleForm:'80%'
      },
      alertaGenero:{
          idelement: "alertaGenero", mensaje:'EL PORCENTAJE DE GENERO DISTRIBUIDO DEBE SUMAR 100%.', elementType:'alerta', showAlertForm: true, name: "alertaGenero", value: "", isError:false, severity: 'error', width:'80%'
      },
      hombres: {
          idelement: "hombres",  value: porcentajeAudienciaHombres, label: "Hombres % *", pattern:"^[0-9]{1,3}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"hombres", 'disabled': false, width: '30%',
      },
      mujeres: {
          idelement: "mujeres",  value: porcentajeAudienciaMujeres, label: "Mujeres % *", pattern:"^[0-9]{1,3}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"mujeres", 'disabled': false, width: '30%',
      },
      nivelSocieconomicoTitulo:{
          idelement: "nivelSocieconomicoTitulo", title:'NIVEL SOCIOECONÓMICO', position:"center", elementType:'titulo', showTitleForm: true, name: "nivelSocieconomicoTitulo", value: "", isError:false, widthTitleForm:'80%'
      },
      alertaNivelSociecomico:{
          idelement: "alertaNivelSociecomico", mensaje:'EL PORCENTAJE DE NIVEL SOCIOECONÓMICO DISTRIBUIDO DEBE SUMAR 100%.', elementType:'alerta', showAlertForm: true, name: "alertaNivelSociecomico", value: "", isError:false, severity: 'error', width:'80%'
      },
      alto: {
          idelement: "alto",  value: nivelSocioEconomicoAlto, label: "Alto % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"alto", 'disabled': false, width: '27%',
      },
      medio: {
          idelement: "medio",  value: nivelSocioEconomicoMedio, label: "Medio % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"medio", 'disabled': false, width: '27%'
      },
      bajo: {
          idelement: "bajo",  value: nivelSocioEconomicoBajo, label: "Bajo % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"bajo", 'disabled': false, width: '26%'
      },
      acciones:{
          idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
      },
    });

    const guardarDatos = async (datosDelFormulario) => {
        const {
            nombreDelMedioEscrito, circulacion, distribucion, logoDelMedio, descripcionDelMedio, correoElectronico, diasDeAnticipacion, comentarioEspecificaciones, tipoEscrito, ratingCanal, alcancePersonas, hombres, mujeres, alto, medio, bajo
        } = datosDelFormulario

        const objetoAEnviar ={
            "idMedioDeComunicacion": datossDelTarifario.medioDeComunicacion?.id,
            "nitEmpresa": nit_empresa,
            "datosDemograficos": {
                alcanceEnPersonas: alcancePersonas,
                "nivelSocioEconomicoAlto": alto,
                "nivelSocioEconomicoBajo": bajo,
                "nivelSocioEconomicoMedio": medio,
                "porcentajeAudienciaHombres": hombres,
                "porcentajeAudienciaMujeres": mujeres,
                "ratingDelMedio": ratingCanal
            },
            "descripcion": descripcionDelMedio,
            "logo": logoDelMedio,
            nombreDelMedioEscrito,
            "recepcionDeMateriales": {
                correoDeRecepcion: correoElectronico,
                diasDeAnticipacion: Number(diasDeAnticipacion),
                especificacionesTecnicasDelMaterial: comentarioEspecificaciones
            },
            tipoDeCirculacion: circulacion?.id,
            tipoDeDistribucion: distribucion?.id,
        tipoDeMedioEscrito: tipoEscrito?.id,
        }

        setcargandoSolicitud(true);

        const datosAEnviar = { controller: "tarifarioDeMediosEscritos", action: "editar", data: objetoAEnviar, nombreDelMetodo: "editar/informacionGeneral" };

        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        setcargandoSolicitud(false);

        if(respuesta?.error) return setDatosDeRespuesta({ tipoDeError: 'error', tipoDeMensaje: respuesta?.error?.message || "Ocurrió un inconveniente, Intente de nuevo!", abrirRespuesta: true, });
        accionRegistroEditado(respuesta?.data)
    }

    const [listadoDeBotones]= React.useState({
      "guardarDatos":{"label":"Guardar Datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
              "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
              "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
              isCancel: false,
      },
      "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
              "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
              "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
              isCancel: true,
      },
  });

    const cerrarAlerta = (_, reason) => {
        if (reason === 'clickaway') {return}
        setDatosDeRespuesta({ tipoDeError: 'error', tipoDeMensaje: "", abrirRespuesta: false, });
    };

    const { tipoDeError, tipoDeMensaje, abrirRespuesta} = datosDeRespuesta;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={handleClose}
            title={title}
            fullscreen={true}
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
                <AlertaDeRespuesta type={tipoDeError} content={tipoDeMensaje} open={abrirRespuesta} handClose={cerrarAlerta}/>
                <Card>
                    <CardContent>
                        <Formulario
                            elements={camposDelFormulario}
                            buttonList={listadoDeBotones}
                        />
                    </CardContent>
                </Card>
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default EditarDatosDeEscritos;